import React, { useEffect, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment, Check, MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { formatDateTime } from "functions/Helper";
import { formatTripDate } from "functions/Helper";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function AgentBookingDetail(props) {
  const classes = useStyles();

  const { id } = useParams();
  const fetchDataSignal = new AbortController();

  const [data, setData] = useState(null);

  const agentBookingNotes = new AbortController();
  const deleteAgentBookingData = new AbortController();

  const [notesPages, setNotesPages] = React.useState(0);
  const [notesData, setNotesData] = React.useState([]);
  const [notesPagination, setNotesPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [notesFilter, setNotesFilter] = React.useState({
    searchString: ""
  });
  const [notesLoading, setNotesLoading] = React.useState(false);

  useEffect(() => {
    fetchData();

    return () => {
      fetchDataSignal.abort();
      agentBookingNotes.abort();
      deleteAgentBookingData.abort();
    };
  }, []);

  useEffect(() => {
    if (id) {
      fetchNotesData();
    }
  }, [id, notesFilter, notesPagination]);

  const fetchData = () => {
    bookingApi
      .get(`AgentBookings/${id}`, {
        signal: fetchDataSignal.signal
      })
      .then(resp => {
        setData(resp);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onDelete = deletedData => {
    setNotesLoading(true);
    bookingApi
      .delete(`AgentBookings/${id}/Notes/${deletedData.id}`, {
        signal: deleteAgentBookingData.signal
      })
      .then(() => {
        fetchNotesData();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setNotesLoading(false);
      });
  };

  const fetchNotesData = () => {
    setNotesLoading(true);
    bookingApi
      .get(`AgentBookings/${id}/Notes`, {
        signal: agentBookingNotes.signal,
        params: {
          filter: notesFilter,
          pagination: notesPagination
        }
      })
      .then(data => {
        setNotesData(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token.is_admin === "True" ||
                    token["booking.agent_booking_notes.delete"] ===
                      "allowed") && (
                    <a
                      onClick={() => {
                        onDelete && onDelete(record);
                      }}
                    >
                      <Button color="rose" className="like">
                        DELETE
                      </Button>
                    </a>
                  )}
                </div>
              )
            };
          })
        );
        setNotesPages(Math.ceil(data.totalRecords / notesPagination.pageSize));
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setNotesLoading(false);
      });
  };

  const handleNotesSearchStringChanged = e => {
    setNotesFilter({
      ...notesFilter,
      searchString: e.target.value === "" ? null : e.target.value
    });
  };

  return (
    <GridContainer>
      {data !== null && (
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>VIEW AGENT BOOKING</h4>
            </CardHeader>
            <CardBody>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <CustomInput
                    disabled
                    labelText="No"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.no ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Confirmation Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.confirmationCode ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Transaction Time"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(
                        new Date(data.transactionTime + "Z")
                      )
                    }}
                  />
                </GridItem>

                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Agent Name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.agent.name ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Route"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.departureCoreApiTrip?.route?.name ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Date"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatTripDate(data.departureCoreApiTrip.date)
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Time"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.departureCoreApiTrip.time ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <FormControlLabel
                    disabled
                    control={
                      <Checkbox
                        checked={data.isRoundTrip}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                          disabled: true
                        }}
                      />
                    }
                    classes={{
                      label: classes.label,
                      root: classes.labelRoot
                    }}
                    label="Is Round Trip"
                  />
                </GridItem>
                {data.isRoundTrip && (
                  <>
                    <GridItem xs={12} md={12}>
                      <FormControlLabel
                        disabled
                        control={
                          <Checkbox
                            checked={data.isReturnTripOpen}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot,
                              disabled: true
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                          root: classes.labelRoot
                        }}
                        label="Is Return Trip Open"
                      />
                    </GridItem>
                    {!data.isReturnTripOpen && (
                      <>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Route"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: data.returnCoreApiTrip.route.name ?? ""
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Date"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: formatTripDate(data.returnCoreApiTrip.date)
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            disabled
                            labelText="Return Time"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              value: data.returnCoreApiTrip.time ?? ""
                            }}
                          />
                        </GridItem>
                      </>
                    )}
                  </>
                )}
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Free Reschedule Times"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.freeRescheduleTimes ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Departure Reschedule Count"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.departureRescheduleCount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <CustomInput
                    disabled
                    labelText="Return Reschedule Count"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.returnRescheduleCount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={3}>
                  <CustomInput
                    disabled
                    labelText="Currency"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.agent?.billingCurrency.code ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={3}>
                  <CustomInput
                    disabled
                    labelText="Total"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.total ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={3}>
                  <CustomInput
                    disabled
                    labelText="Voucher Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.voucherAmount ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={3}>
                  <CustomInput
                    disabled
                    labelText="Grand Total"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: data.outstandingAmount ?? ""
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      )}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Agent Booking Notes</h4>
          </CardHeader>
          <CardBody>
            {(token.is_admin === "True" ||
              token["booking.agent_booking_notes.write"] === "allowed") && (
              <Link to={"/admin/AgentBooking/AddNotes/" + id}>
                <Button color="rose" type="button" value="Create">
                  Create
                </Button>
              </Link>
            )}
            <GridItem xs={12} md={6}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleNotesSearchStringChanged,
                  value:
                    notesFilter.searchString === null
                      ? ""
                      : notesFilter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={notesPages}
              page={notesPagination.pageIndex - 1}
              pageSize={notesPagination.pageSize}
              onPageChange={page =>
                setNotesPagination({
                  pageIndex: page + 1,
                  pageSize: notesPagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setNotesPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={notesLoading}
              data={notesData}
              filterable={false}
              columns={[
                {
                  Header: "Note",
                  accessor: "note"
                },
                {
                  id: "createdAt",
                  Header: "Created At",
                  accessor: d =>
                    d.createdAt ? formatDateTime(d.createdAt + "Z") : "-"
                },
                {
                  Header: "Created By",
                  accessor: "createdBy"
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

AgentBookingDetail.propTypes = {
  history: PropTypes.object
};
